module.exports = __webpack_public_path__ + "img/lg_ring_g_o_0_null@3x.7e863b7e.png";